import { Action } from "@ngrx/store";
import { InfoProfesionalError, InfoProfesionalEstadoEnum, RedSocialDisponible, SaveInfoProfesionalBody, UsuarioContacto, UsuarioInfoProfesional, UsuarioPerfil } from "../../common/informacion-personal";

export enum InformacionPersonalActionTypes {
	UsuarioInfoCleared = '[InformacionPersonal Component] Usaurio Info Cleared',
	UsuarioPerfilRequested = '[InformacionPersonal Component] Usuario Perfil Requested',
	UsuarioPerfilAlreadyLoaded = '[InformacionPersonal API] Usuario Perfil Already Loaded',
	UsuarioPerfilLoaded = '[InformacionPersonal API] Usuario Perfil Loaded',
	UsuarioPerfilCancelled = '[InformacionPersonal API] Usuario Perfil Cancelled',
	UsuarioContactoRequested = '[InformacionPersonal Component] Usuario Contacto Requested',
	UsuarioContactoLoaded = '[InformacionPersonal API] Usuario Contacto Loaded',
	UsuarioContactoCancelled = '[InformacionPersonal API] Usuario Contacto Cancelled',
	UsuarioInfoProfesionalRequested = '[InformacionPersonal Component] Usuario InfoProfesional Requested',
	UsuarioInfoProfesionalLoaded = '[InformacionPersonal API] Usuario InfoProfesional Loaded',
	UsuarioInfoProfesionalCancelled = '[InformacionPersonal API] Usuario InfoProfesional Cancelled',
	RedesDisponiblesRequested = '[InformacionPersonal Component] Redes Disponibles Requested',
	RedesDisponiblesLoaded = '[InformacionPersonal API] Redes Disponibles Loaded',
	RedesDisponiblesCancelled = '[InformacionPersonal API] Redes Disponibles Cancelled',
	RedesDisponiblesAlreadyLoaded = '[InformacionPersonal API] Redes Disponibles Already Loaded',
	StartEditingInfoProfesional = '[InformacionPersonal Component] Start Editing InfoProfesional',
	CancelEditingInfoProfesional = '[InformacionPersonal Component] Cancel Editing InfoProfesional',
	SaveEditingInfoProfesionalRequested = '[InformacionPersonal Component] Save Editing InfoProfesional Requested',
	SaveEditingInfoProfesionalSuccess = '[InformacionPersonal API] Save Editing InfoProfesional Success',
	SaveEditingInfoProfesionalError = '[InformacionPersonal API] Save Editing InfoProfesional Error',
	SaveEditingInfoProfesionalInvalid = '[InformacionPersonal API] Save Editing InfoProfesional Invalid',

	// Buscador personas related actions
	SetEstadoInfoProfesional = '[Buscador Personas Component] Set Estado InfoProfesional',
}

export class UsuarioInfoCleared implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioInfoCleared;
	constructor() {}
}

export class UsuarioPerfilRequested implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioPerfilRequested;
	constructor() {
	}
}

export class UsuarioPerfilLoaded implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioPerfilLoaded;
	constructor( public payload: { perfil: UsuarioPerfil } ) {
	}
}

export class UsuarioPerfilCancelled implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioPerfilCancelled;
	constructor() {
	}
}

export class UsuarioContactoRequested implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioContactoRequested;
	constructor() {
	}
}

export class UsuarioContactoLoaded implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioContactoLoaded;
	constructor( public payload: { contacto: UsuarioContacto } ) {
	}
}

export class UsuarioContactoCancelled implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioContactoCancelled;
	constructor() {
	}
}

export class UsuarioPerfilAlreadyLoaded implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioPerfilAlreadyLoaded;
	constructor() {
	}
}

// Reseña y Redes sociales

export class RedesDisponiblesRequested implements Action {
	readonly type: string = InformacionPersonalActionTypes.RedesDisponiblesRequested;
	constructor() {}
}

export class RedesDisponiblesLoaded implements Action {
	readonly type: string = InformacionPersonalActionTypes.RedesDisponiblesLoaded;
	constructor( public payload: { redesDisponibles: RedSocialDisponible[] } ) {}
}

export class RedesDisponiblesAlreadyLoaded implements Action {
	readonly type: string = InformacionPersonalActionTypes.RedesDisponiblesAlreadyLoaded;
	constructor() {}
}

export class RedesDisponiblesCancelled implements Action {
	readonly type: string = InformacionPersonalActionTypes.RedesDisponiblesCancelled;
	constructor() {}
}

export class UsuarioInfoProfesionalRequested implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioInfoProfesionalRequested;
	constructor() {}
}

export class UsuarioInfoProfesionalLoaded implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioInfoProfesionalLoaded;
	constructor( public payload: { infoProfesional: UsuarioInfoProfesional } ) {}
}

export class UsuarioInfoProfesionalCancelled implements Action {
	readonly type: string = InformacionPersonalActionTypes.UsuarioInfoProfesionalCancelled;
	constructor() {}
}

export class StartEditingInfoProfesional implements Action {
	readonly type: string = InformacionPersonalActionTypes.StartEditingInfoProfesional;
	constructor() {}
}

export class CancelEditingInfoProfesional implements Action {
	readonly type: string = InformacionPersonalActionTypes.CancelEditingInfoProfesional;
	constructor() {}
}

export class SaveEditingInfoProfesionalRequested implements Action {
	readonly type: string = InformacionPersonalActionTypes.SaveEditingInfoProfesionalRequested;
	constructor( public payload: { infoProfesional: SaveInfoProfesionalBody } ) {}
}

export class SaveEditingInfoProfesionalSuccess implements Action {
	readonly type: string = InformacionPersonalActionTypes.SaveEditingInfoProfesionalSuccess;
	constructor() {}
}

export class SaveEditingInfoProfesionalError implements Action {
	readonly type: string = InformacionPersonalActionTypes.SaveEditingInfoProfesionalError;
	constructor() {}
}

export class SaveEditingInfoProfesionalInvalid implements Action {
	readonly type: string = InformacionPersonalActionTypes.SaveEditingInfoProfesionalInvalid;
	constructor( public payload: { errors: InfoProfesionalError } ) {}
}

// Buscador personas related actions
export class SetEstadoInfoProfesional implements Action {
	readonly type: string = InformacionPersonalActionTypes.SetEstadoInfoProfesional;
	constructor( public payload: { estado: InfoProfesionalEstadoEnum } ) {}
}

export type InformacionPersonalAction = UsuarioInfoCleared | UsuarioPerfilRequested | UsuarioPerfilLoaded | UsuarioPerfilCancelled |
	UsuarioContactoRequested | UsuarioContactoLoaded | UsuarioContactoCancelled | RedesDisponiblesRequested |
	RedesDisponiblesLoaded | RedesDisponiblesCancelled | RedesDisponiblesAlreadyLoaded | UsuarioInfoProfesionalRequested |
	UsuarioInfoProfesionalLoaded | UsuarioInfoProfesionalCancelled |
	StartEditingInfoProfesional | CancelEditingInfoProfesional | SaveEditingInfoProfesionalRequested |
	SaveEditingInfoProfesionalSuccess | SaveEditingInfoProfesionalError | SaveEditingInfoProfesionalInvalid | SetEstadoInfoProfesional;